import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from 'react-redux';
import _route from "../constants/routes";

export default function PrivateRoute({ allowedRoles }) {
  const user = useSelector((state) => state.auth.user);

  if (!user) {
    return <Navigate to={_route._login} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={_route._dashboard} />;
  }

  return <Outlet />;
}
